import {
    LabelBody,
    LabelBodyHeadline,
    LabelDisplay1,
} from '../../modules/components';
import { ExerciseDto, Question } from '../../modules/interfaces';

export type Props = {
    className?: string;
    exercise: ExerciseDto;
    title: string;
    description?: React.ReactNode;
    answerTitle?: string;
    answers: string[];
};
export function QuestionView({
    className,
    title,
    description,
    answerTitle = 'Dit svar',
    answers,
}: Props) {
    return (
        <div className={className}>
            <LabelDisplay1>{title}</LabelDisplay1>
            <LabelBody class="mb-20 mt-10">{description}</LabelBody>
            <LabelBodyHeadline color="text-dark-red">
                {answerTitle}
            </LabelBodyHeadline>
            {answers.map((x, idx) => (
                <LabelBody key={idx} class="whitespace-pre-wrap">
                    “{x.trim()}”
                </LabelBody>
            ))}
        </div>
    );
}

type Configuration = {
    /// The data keys holding the answers to the question. This must contain at least one key for the question to be displayed.
    dataKeys: string[];
    /// True if the answers are JSON-encoded arrays
    isArray?: boolean;
    title: string;
    description: React.ReactNode;
};
export function createQuestionFromConfiguration({
    title,
    description,
    ...common
}: Configuration): Question {
    return {
        ...common,
        Answers: (props) => (
            <QuestionView {...props} title={title} description={description} />
        ),
    };
}
